const SET_TRIP_SELECTION_STATUS = 'SET_TRIP_SELECTION_STATUS';

const setTripSelectionStatus = tripSelectionStatus => ({
  type: SET_TRIP_SELECTION_STATUS,
  payload: tripSelectionStatus,
});

export { SET_TRIP_SELECTION_STATUS, setTripSelectionStatus };
